// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parent-league-container .v-text-field__details {\n  display: none;\n}\n.parent-league-container .v-messages {\n  display: none;\n}\n.parent-league-container .v-list-item__title {\n  text-transform: tw-capitalize;\n}\n.parent-league-container .leagues-container .v-select__selection {\n  text-transform: tw-capitalize;\n}\n.parent-league-container .leagues-table tr {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
